// Empresas que usan permisos por boton (asi quedo por la restriccion a las otras empresas xd)
export const EMPRESAS_PERMISOS_BOTONES = [49, 50];